export const onDOMReady = (action: () => void) => {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
            action();
        });
    } else {
        action();
    }
};
